import "./components/*";
import AOS from 'aos';
import "@splidejs/splide/dist/css/splide.min.css";
import 'aos/dist/aos.css';

AOS.init();